import React from 'react';
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import {AuthProvider} from './AuthContext';
import {SwapMainAppProvider} from "./SwapMainAppContext";
import {DashboardDataProvider} from "./dashboard/context/DashboardDataContext";
import GatewayTokenVerifier from './GatewayTokenVerifier';
import TransactionHistory from "./tables/TransactionHistory/TransactionHistory";
import C2CNetwork from "./tables/C2C NetWork/C2CNetwork";
import EmailSwapMainAPP from "./tables/EmailSwapMainAPP/EmailSwapMainAPP";
import Account from "./tables/Account/Account";
import GatewayTokenVerifier2 from "./GatewayTokenVerifier2";
import InviteFriends from "./tables/InviteFriends/InviteFriends";
import ReferralLandingPage from "./tables/InviteFriends/ReferralLandingPage";
import DashboardPage from "./tables/Dashboard/DashboardPage";
import AnalyticsPage from "./tables/Analytics/AnalyticsPage";
import LoginEmailPage from "./LoginEmailPage";
import EmailVerifyPage from "./EmailVerifyPage";
/**
 * 当访问 "/" 时，检查 localStorage 是否存在 gatewayToken。
 * - 如果存在，则重定向到 /swap?token=<gatewayToken>
 * - 如果不存在，则渲染 SwapMainAPP
 */


const App = () => {
  return (
    <AuthProvider>
      <SwapMainAppProvider>
        <Router>
          <DashboardDataProvider>
          <Routes>
            {/*
              used GatewayTokenVerifier2 to replace <SwapMainAPP />
            */}
            <Route path="/" element={<GatewayTokenVerifier2 />} />

            <Route path="/transaction" element={<TransactionHistory />} />
            <Route path="/c2c" element={<C2CNetwork />} />
            <Route path="/account" element={<Account />} />
            <Route path="/invite" element={<InviteFriends />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/email-login" element={<LoginEmailPage />} />
            <Route path="/email-verify" element={<EmailVerifyPage />} />
            <Route
              path="/invite-friend/:referralCode"
              element={<ReferralLandingPage />}
            />
            {/* Gateway route: verify token before showing Swap */}
            <Route
              path="/swap"
              element={
                <GatewayTokenVerifier>
                    <EmailSwapMainAPP />
                 </GatewayTokenVerifier>
              }
            />

            {/* 捕获所有未匹配的路由并重定向到 / */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          </DashboardDataProvider>
        </Router>
      </SwapMainAppProvider>
    </AuthProvider>
  );
};

export default App;
